import styled from "styled-components";
import Image4 from "../../assets/images/supplier-back.jpg";

export const StyledSection = styled.section`
  padding: 4rem 4rem;
  .header-text {
    height: 300px;
  }
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 72px;
    line-height: 81px;
    color: ${({ theme }) => theme.colors.primary};
  }
  h2 {
    margin-top: 1rem;
    font-style: normal;
    font-weight: bold;
    font-size: 38px;
    line-height: 42px;
    color: #030068;
  }
  .hh2 {
    font-style: normal;
    font-weight: bold;
    font-size: 38px;
    line-height: 42px;
    color: #030068;
    max-width: 60%;
    text-align: center;
    margin: 1rem auto;
  }
  p {
    margin-top: 2rem;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: black;
  }

  @media (max-width: 768px) {
    padding: 4rem 0px;

    .header-text {
      height: 200px;
    }
    h1 {
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 40px;
      color: ${({ theme }) => theme.colors.primary};
    }
    h2 {
      font-size: 26px;
      line-height: 30px;
    }
    .hh2 {
      font-size: 26px;
      line-height: 30px;
      max-width: 100%;
    }

    p {
      margin-top: 1rem;
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      color: black;
    }
  }
`;
export const StyledCover = styled.section`
  background-image: url(${Image4});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 550px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  h1 {
    position: absolute;
    color: ${({ theme }) => theme.colors.textColor};
    font-style: normal;
    font-size: 38px;
    line-height: 43px;
    right: 0;
    width: 50%;
    font-weight: bold;
  }
  @media (max-width: 768px) {
    h1 {
      position: relative;
      font-size: 26px;
      padding: 1rem;
      line-height: 32px;
      width: 100%;
      text-align: center;
    }
  }
`;
